/**
 * The page is imported from **its own module**, not from the `@pages` barrel — the barrel re-exports
 * every page, so one import would pull all of them into the chunk the entry preloads.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DocumentPreviewPage } from '@pages/documents/document-preview-page.js';
import { DocumentModel } from '@units/document';
import { IamService } from '@units/iam';

/**
 * `/documents/$documentId` — wiring only (`rules/frontend-fsd.mdc` rule 10).
 *
 * Гард тот же, что у реестра, — `document:read`, и по той же причине: раздел «Документы» стоит в
 * навигации каждого, кто держит право, поэтому его существование не секрет и отказ может назвать,
 * чего не хватает. **Сам документ секрет**: документ чужой организации, приватное вложение чужого
 * разговора и идентификатор, не называющий ничего, отвечают одинаково — `404`, и решает это сервер.
 *
 * **Схема адреса несёт день и страницу.** День под каноническим именем `asOf`
 * (`rules/legal-documents.mdc` §15): экран, показывающий редакцию на прошлую дату, обязан быть
 * ссылкой, а не последовательностью кликов, — иначе «редакция на 01.03.2026» открывается у
 * получателя сегодняшней, то есть другим документом.
 *
 * Импорт **конкретного модуля страницы**, а не бочки `@pages/documents`: бочка тянет за собой экран
 * реестра, и оба маршрута оказались бы в одном чанке — то самое разделение по маршрутам, отменённое
 * одним импортом.
 */
export const Route = createFileRoute('/_authenticated/documents/$documentId')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'document:read',
    whenDenied: 'forbidden',
  }),
  validateSearch: DocumentModel.documentPreviewSearchSchema,
  component: DocumentPreviewPage,
  staticData: { crumbKey: 'documents.preview.title' },
});
